<template>
  <div class="weui-container">
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast fit-t-c" role="alertdialog" tabindex="-1" aria-modal="true"
      :class="[{ 'weui-toast__dot_type': showDotLine }]">
      <slot name="icon">
          <FitIcon :icon="icon" class="weui-icon_toast" size="91" fill="#fff"></FitIcon>
      </slot>
      <div class="weui-toast__content" :class="[{ 'weui-toast__content__dot': showDotLine }]">
        <slot></slot>
        <div class="weui-toast__dot-line" v-if="showDotLine">
          <div class="weui-toast__dot"></div>
          <div class="weui-toast__dot"></div>
          <div class="weui-toast__dot"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import FitIcon from '../../icon';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    FitIcon,
  },
})
export default class FitToast extends Vue {
  @Prop({ default: false }) public showDotLine!: boolean;
  @Prop({ default: 'success-no-circle' }) public icon!: string;
  @Prop({ default: 200 }) size;
}
</script>
